import { render, staticRenderFns } from "./contactTodo.vue?vue&type=template&id=01757b3b&scoped=true&"
import script from "./contactTodo.vue?vue&type=script&lang=js&"
export * from "./contactTodo.vue?vue&type=script&lang=js&"
import style0 from "./contactTodo.vue?vue&type=style&index=0&id=01757b3b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01757b3b",
  null
  
)

export default component.exports